import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"

import { useNetworksStateContext } from "../contexts/NetworksContext"

import { networksQueryKeys } from "./queryKeys"

export function useNetworkSubnetworksLength(subNetworks = null, config = {}) {
    const { selectedNetwork, selectedSubNetworkSlugs = [] } = useNetworksStateContext()

    const subNetworksToUse = subNetworks ?? selectedSubNetworkSlugs

    const url = `/network/networks/${selectedNetwork.slug}/length/`
    const params = {
        sub_networks: subNetworksToUse.join(","),
    }
    const queryKey = networksQueryKeys.stats(selectedNetwork.slug, params)

    const { enabled = true } = config

    return useAuthenticatedQuery(
        url,
        queryKey,
        params,
        {
            ...config,
            enabled: enabled && subNetworksToUse.length > 0,
        },
    )
}